module.exports = __webpack_public_path__ + "static/media/icon-fitwel.95598487.svg";